export const SERVER = "https://terradata.com.br/";

export const LOGIN = SERVER + 'api/controller/auth/login.php';

export const CONTACT = 'https://growlingstork-n8n.cloudfy.live/webhook/35508a24-2a64-4fd2-a594-bfc9bd1b41a1'

export const APPLICATIONS_LIST = SERVER + 'api/controller/application/list.php';
export const APPLICATIONS_CREATE = SERVER + 'api/controller/application/create.php';
export const APPLICATIONS_UPDATE = SERVER + 'api/controller/application/update.php';
export const APPLICATIONS_DELETE = SERVER + 'api/controller/application/delete.php';

export const COMMITMENTS_LIST = SERVER + 'api/controller/commitment/list.php';
export const COMMITMENTS_CREATE = SERVER + 'api/controller/commitment/create.php';
export const COMMITMENTS_UPDATE = SERVER + 'api/controller/commitment/update.php';
export const COMMITMENTS_DELETE = SERVER + 'api/controller/commitment/delete.php';

export const EXTERNAL_SYSTEMS_LIST = SERVER + 'api/controller/externalsystem/list.php';
export const EXTERNAL_SYSTEMS_CREATE = SERVER + 'api/controller/externalsystem/create.php';
export const EXTERNAL_SYSTEMS_UPDATE = SERVER + 'api/controller/externalsystem/update.php';
export const EXTERNAL_SYSTEMS_DELETE = SERVER + 'api/controller/externalsystem/delete.php';

export const LICENSE_TYPES_LIST = SERVER + 'api/controller/license-type/list.php';
export const LICENSE_STATUS_LIST = SERVER + 'api/controller/license-status/list.php';

export const LICENSES_LIST = SERVER + 'api/controller/license/list.php';
export const LICENSES_CREATE = SERVER + 'api/controller/license/create.php';
export const LICENSES_UPDATE = SERVER + 'api/controller/license/update.php';
export const LICENSES_DELETE = SERVER + 'api/controller/license/delete.php';

export const PROFILE_CREATE = SERVER + 'api/controller/profile/create.php';
export const PROFILE_UPDATE = SERVER + 'api/controller/profile/update.php';

export const USER_TYPES_LIST = SERVER + 'api/controller/user-type/list.php';
export const USER_STATUS_LIST = SERVER + 'api/controller/user-status/list.php';

export const USERS_LIST = SERVER + 'api/controller/user/list.php';
export const USERS_CREATE = SERVER + 'api/controller/user/create.php';
export const USERS_UPDATE = SERVER + 'api/controller/user/update.php';
export const USERS_DELETE = SERVER + 'api/controller/user/delete.php';